import { render } from "./PenilaianTeknis.vue?vue&type=template&id=c773a7c6&scoped=true"
import script from "./PenilaianTeknis.vue?vue&type=script&lang=js"
export * from "./PenilaianTeknis.vue?vue&type=script&lang=js"

import "./PenilaianTeknis.vue?vue&type=style&index=0&id=c773a7c6&lang=css&scoped=true"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c773a7c6"]])

export default __exports__